import Records from '../ItemPopup/Records';
import Achievements from '../ItemPopup/Achievements';
import Photos from '../Uploads/Photos';
import PhotosWinterGrazingWithoutId from '../Uploads/PhotosWinterGrazingWithoutId';
const ItemCommonBottomWinterGrazing = ({itemType, itemPopup, itemPopupAchievements, handleItemPopupAchievements, Section, setImageUploadList, imageUploadList }) => {
    return (
        <div>
            {itemType == 'Paddock' &&
                <PhotosWinterGrazingWithoutId setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} disabledMode={false} refId={itemPopup.itemId} header="Map" uploadType="Item" ></PhotosWinterGrazingWithoutId>
            }
        </div>
    )
}
export default ItemCommonBottomWinterGrazing